import "./App.scss"
import { observer } from "mobx-react"
import React, { Component } from "react"
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom"
import { TransitionRoute, Loading, Scroll, getUserConfirmation } from "../lib"
import Dashboard from "../dashboard/Dashboard"
import Channel from "../channel/Channel"
import AddChannel from "../channel/add/AddChannel"
import Account from "../account/Account"
import Auth from "../auth/Auth"
import SideBar from "./SideBar"
import NoMatch from "./NoMatch"
import { authStore } from "./stores"

class App extends Component {
  render() {
    const { authenticated, authenticating } = authStore
    return (
      <Router getUserConfirmation={getUserConfirmation}>
        <div className="App">
          {authenticated ? (
            <Scroll resetOnRouteChange>
              <div className="App_container">
                <SideBar />
                <Switch>
                  <Route path="/dashboard" component={Dashboard} />
                  <Route path="/account" component={Account} />
                  <Route path="/channel/:channelId" component={Channel} />
                  <TransitionRoute path="/add" component={AddChannel} />
                  <Route
                    path="/"
                    exact
                    render={() => <Redirect to={"/dashboard"} />}
                  />
                  <Route component={NoMatch} />
                </Switch>
              </div>
            </Scroll>
          ) : (
            <Route path="/" component={Auth} />
          )}
          <Loading loading={authenticating} />
        </div>
      </Router>
    )
  }
}

App.displayName = "App"

export default observer(App)



// WEBPACK FOOTER //
// ./src/app/App.js